import React from 'react';
import { Col, Row } from 'antd';
import { SectionLayout } from 'components/Sections/SectionLayout';
import ListingScansForm from 'components/Form/ListingScanForm';
import facebookIcon from '../images/facebook-icon.svg';
import googleIcon from '../images/google-icon.svg';
import nextdoorIcon from '../images/nextdoor-icon.png';
import yellowPagesIcon from '../images/yellowpages-icon.png';
import yelpIcon from '../images/yelp-icon.svg';

import { Container } from './styles';

const MarketingProListingsScan = ({ form }) => (
  <Container>
    <SectionLayout contentBelowSection={false}>
      <div className="marketing-pro-listings-scan--title">
        <h2 color="white" fontSize="normal">
          Control the facts about your business -<br /> everywhere your customers are searching
        </h2>
      </div>
      <div className="marketing-pro-listings-scan--icons">
        <img src={facebookIcon} className="marketing-pro-listings-scan--icon" />
        <img src={googleIcon} className="marketing-pro-listings-scan--icon" />
        <img src={nextdoorIcon} className="marketing-pro-listings-scan--icon" />
        <img src={yellowPagesIcon} className="marketing-pro-listings-scan--icon" />
        <img src={yelpIcon} className="marketing-pro-listings-scan--icon" />
      </div>
      <Row justify="center" type="flex">
        <Col xs={24} md={20}>
          <ListingScansForm form={form} />
        </Col>
      </Row>
    </SectionLayout>
  </Container>
);

export default MarketingProListingsScan;
